<template>
  <div class="teamSBtable" v-loading="loadingTrue">
    <el-table
      :data="tableData"
      :header-cell-style="setColumnDataColor"
      :cell-style="setCellStyle"
      style="width: 100%"
      v-if="!loadingTrue"
    >
      <template slot="empty">
        <img src="@/static/img/cailiao.png" alt style="margin-bottom:10px;line-height:0px;margin-top:50px;width:100px" />
        <p class="noText" style="color:#666666;fontSize:16px;line-height:30px;margin-bottom:50px">暂无数据</p>
      </template>
      <el-table-column  label="设备名称" prop="name" show-overflow-tooltip width="100" >
        <template slot-scope="scope">
           <span style="color:#0286DF">{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column  label="设备分类" prop="equipmentTypeName" show-overflow-tooltip width="200" >
        <template slot-scope="scope">
           <span style="color:#666">{{ scope.row.equipmentTypeName?scope.row.equipmentTypeName:'/' }}</span>
        </template>
      </el-table-column>
      <el-table-column  label="设备简介" prop="describe" show-overflow-tooltip width="200"></el-table-column>
      <el-table-column  label="设备型号" prop="model" show-overflow-tooltip width="100">
         <template slot-scope="scope">
           <span>{{ scope.row.model?scope.row.model:'/' }}</span>
        </template>
      </el-table-column>
      <el-table-column  label="设备数量" prop="countNum" show-overflow-tooltip width="100"></el-table-column>
      <el-table-column  label="设备年限" prop="years" show-overflow-tooltip width="100">
        <template slot-scope="scope">
           <span>{{ scope.row.years?scope.row.years+"年":'/' }}</span>
        </template>
      </el-table-column>
      <el-table-column  label="设备图片" prop="contactPhone"  width="100">
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.picture"
            style="width: 50px; height: 40px;margin-top:5px;"
            :src="scope.row.picture.split(',')[0]"
            :preview-src-list="scope.row.picture.split(',')"
            fit="cover"
          ></el-image>
          <div slot="error" v-else>
            <span>/</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="所属工队" width="198">
        <template slot-scope="scope">
          <el-tooltip trigger="hover" placement="top-start" :disabled="false">
            <p style="max-width: 260px;"  slot="content">
              {{ scope.row.teamName }}
            </p>
            <div class="text_ellipsis">
              {{ $parent.$parent.$parent.detail.teamName }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column  label="设备权属" prop="status" show-overflow-tooltip width="100">
        <template slot-scope="scope">
           <!-- <span>{{ scope.row.status?scope.row.status:'/' }}</span> -->
           <span v-if="scope.row.equipmentOwnershipType==null">{{ "/" }}</span>
           <span v-if="scope.row.equipmentOwnershipType === 0">自有</span>
           <span v-if="scope.row.equipmentOwnershipType === 1">租赁</span>
        </template>
      </el-table-column>
      <!-- <el-table-column  label="操作" width="100">
        <template slot-scope="scope">
          <el-button type="text" @click="$refs.teamSBtableDetail.open(scope.row.no)">查看详情</el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <TeamSBtableDetail ref="teamSBtableDetail" />
    <Pagination :param="param" @change="getEquipment" v-if="tableData.length!=0" :loadingTrue="loadingTrue"></Pagination>
  </div>
</template>

<script>
import { setColumnDataColor, setCellStyle } from '@/views/Home/components/style.js'
import { apiTeamDetail } from '@/api/apiTeamDetail'
export default {
  data () {
    return {
      setColumnDataColor,
      setCellStyle,
      loadingTrue: false,
      tableData: [],
      param: {
        page: 1,
        limit: 20,
        teamNo: '',
        companyNo: '',
        userNo: '',
        total: 0,
        type: 0
      }
    }
  },

  components: {
    Pagination: () => import('@/views/Construction/components/Pagination'), // 分页
    TeamSBtableDetail:()=>import('./TeamSBtableDetail'), // 专业设备详情弹窗
  },
  created () {
    this.getEquipment()
  },
  methods: {
    async getEquipment () {
      this.loadingTrue = true
      if (this.$route.query.teamNo) this.param.teamNo = this.$route.query.teamNo
      // if(this.$route.query.companyNo) this.param.companyNo = this.$route.query.companyNo;
      let res = await apiTeamDetail.getEquipment(this.param)
      if (res.data.code === 200) {
        this.tableData = res.data.data.records
        this.param.total = res.data.data.total
        this.loadingTrue = false
      } else {
        this.loadingTrue = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
 /deep/ .el-table__empty-text{
  line-height: 0px;

}
 /deep/.cell{
   padding: 0 20px !important;
 }
 /deep/td{
   height: 44px !important;
 }
 /deep/th{
   height: 50px !important;
   padding: 10px 0 !important;
 }
 /deep/tr{
   height: 50px!important;
 }
 .text_ellipsis {
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
 }
</style>
